import { render, staticRenderFns } from "./editContractPartya.vue?vue&type=template&id=48d9d4ca"
import script from "./editContractPartya.vue?vue&type=script&lang=js"
export * from "./editContractPartya.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports